import { Component, ViewChild } from '@angular/core';
import { ListarTareasComponent } from '../../forms/tareas/listar-tareas/listar-tareas.component';

@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.scss']
})
export class CalendarioComponent {
  @ViewChild('listadoTareas') listadoTareas: ListarTareasComponent

  constructor() { }

  actualizarListadoTareas(): void {
    if (this.listadoTareas) {
      this.listadoTareas.traerTareasDia();
    }
  }
}
